// src/components/header/Header.tsx
import React from "react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext"; // adjust if your useAuth path is different
import logo from "../../assets/img/HT-Logo.svg"; // adjust path if needed

const Header: React.FC = () => {
  const { idToken, logOut } = useAuth();
  const navigate = useNavigate();

  return (
    <AppBar position="static" color="primary" sx={{ mb: 3 }}>
      <Toolbar>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            flexGrow: 1,
          }}
          onClick={() => navigate("/dashboard")}
        >
          <img
            src={logo}
            alt="HT-Logo"
            style={{ height: 40, marginRight: 16 }}
          />
          <Typography
            variant="h6"
            sx={{ textDecoration: "none", fontWeight: 500 }}
          >
            Supplier Portal
          </Typography>
        </Box>
        {idToken && (
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button color="inherit" component={Link} to="/dashboard">
              Dashboard
            </Button>
            <Button color="inherit" component={Link} to="/users">
              Users
            </Button>
            <Button color="inherit" onClick={() => logOut()}>
              Logout
            </Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
